import React, { useState } from "react";
import { useNavigate } from 'react-router-dom';
import VeryconVariants2 from "../../Assets/products_landing/4.svg"
import VeryconVariants2Left from "../../Assets/products_landing/verycon2.png"
import { IoChevronForwardOutline } from 'react-icons/io5';
import { BsArrowRightShort } from 'react-icons/bs';
import FormModal from "../ProductsLanding/FormModal";

const Verycon2 = () => {
    const navigate = useNavigate();
    const [productTitle, setProductTitle] = useState("");
    const [isModalOpen, setIsModalOpen] = useState(false);

    const openModal = () => {

        setIsModalOpen(true)
    };
    return (
        // <section className="bg-light-gradient-white blade-margin-top-sm">
        //     <div className="containers-min mx-auto px-4 py-12">
        //         <div className="2xl:pb-20 xl:pb-16 lg:pb-12 md:pb-8 pb-0">
        //             <h3 className="text-center font-gilroy">
        //                 AC Charger Controller - Verycon 2.0
        //             </h3>
        //             <p className="my-3 md:my-5 lg:my-7 text-center font-poppins font-light">
        //                 Presenting Verycon 2.0 Charger Controller, your pathway towards building intelligent triple gun EV Chargers! Build multi-faceted EVSEs with features that fulfill your product strategy.
        //             </p>
        //         </div>

        //         <div className="flex flex-col md:flex-row">
        //             <div className="w-full md:w-1/2">
        //                 <img src={VeryconVariants2} alt="VeryconVariants2" />
        //                 <div className="flex items-center py-2 sm:py-3 gap-3">
        //                     <div onClick={() => {
        //                         navigate('/get-in-touch')
        //                     }}>
        //                         <button
        //                             className='btn-new font-semibold relative flex justify-center items-center rounded-full pl-16 pr-6'
        //                         >
        //                             <span className="flex justify-center items-center">
        //                                 <IoChevronForwardOutline className="h-[22px] w-[25px] ioArrow" />
        //                                 <BsArrowRightShort className="h-[30px] w-[30px] tailArrow" />
        //                             </span>
        //                             Get Quote
        //                         </button>
        //                         {/* <Button title="Contact Us" /> */}
        //                     </div>

        //                     <div className='group cursor-pointer'>
        //                         <a href="" target="_blank" className='text-gray-600'>
        //                             <button
        //                                 className='btn-new font-semibold relative flex justify-center items-center rounded-full pl-16 pr-6'
        //                             >
        //                                 <span className="flex justify-center items-center">
        //                                     <IoChevronForwardOutline className="h-[22px] w-[25px] ioArrow" />
        //                                     <BsArrowRightShort className="h-[30px] w-[30px] tailArrow" />
        //                                 </span>
        //                                 Brochure
        //                             </button>
        //                         </a>
        //                     </div>
        //                 </div>
        //             </div>
        //             <div className="w-full md:w-1/2">
        //                 <div className="grow shrink flex justify-center items-center relative min-h-[300px] sm:min-h-[400px] md:min-h-[550px] lg:min-h-[650px] xxl:min-h-[800px]">
        //                     <div className="absolute top-0 left-auto bottom-0 right-0 bg-gradient w-32 md:w-56 lg:w-80"></div>
        //                     <div className="mx-3 md:w-10/12  md:max-w-[850px] max-w-sm grid place-content-center md:px-10 lg:px-20  bg-grey z-10 h-5/6 lg:h-4/5 rounded-3xl overflow-hidden relative ">
        //                         {/* <img
        //                         loading="lazy"
        //                         src={tabData[activeIdx].imgSrc}
        //                         alt={tabData[activeIdx].title}
        //                         className="mx-auto my-auto object-contain object-center lg:mb-10 z-10"
        //                     /> */}
        //                         <img src={VeryconVariants2Left} alt="VeryconVariants2" />
        //                     </div>
        //                 </div>
        //             </div>
        //         </div>
        //     </div>
        // </section >
        <section className="bg-light-gradient blade-margin-top-sm">            
            <div className="2xl:pb-20 xl:pb-16 lg:pb-12 md:pb-8 pb-0 containers-min mx-auto">
                <h3 className="text-center font-gilroy">
                    AC Charger Controller - Verycon 2.0
                </h3>
                <p className="my-3 md:my-5 lg:my-7 text-center font-poppins font-light">
                    Presenting Verycon 2.0 Charger Controller, your pathway towards building intelligent triple gun EV Chargers! Build multi-faceted EVSEs with features that fulfill your product strategy
                </p>
            </div>
            <div className="flex xLg:flex-row flex-col-reverse gap-3 relative gap-y-6">                
                <div className=" basis-32  xl:basis-20 grow shrink  col-end-7 flex items-center flex-col lg:justify-end px-3 pl-5 lg:pl-20 xl:pl-10">
                    <h5 className="font-semibold font-gilroy">AC Charger Output Configuration</h5>
                    <img src={VeryconVariants2} alt="VeryconVariants2" className="mb-16" />
                    {/* <div className="flex items-center py-2 sm:py-3 gap-3 w-full sm:w-2/3"> */}
                    <div className="flex items-center mt-16 py-2 sm:py-3 gap-3 w-full sm:w-2/3">

                        <div onClick={() => {
                            openModal()
                            setProductTitle("AC Charger Controller - Verycon 2.0")
                        }}>
                            <button
                                className='btn-new font-semibold relative flex justify-center items-center rounded-full pl-16 pr-6 font-poppins'
                            >
                                <span className="flex justify-center items-center">
                                    <IoChevronForwardOutline className="h-[22px] w-[25px] ioArrow" />
                                    <BsArrowRightShort className="h-[30px] w-[30px] tailArrow" />
                                </span>
                                Get Quote
                            </button>
                            {/* <Button title="Contact Us" /> */}
                        </div>
                        
                        <div className='group cursor-pointer'>
                            <a href="" target="_blank" className='text-gray-600'>
                                <button
                                    className='btn-new font-semibold relative flex justify-center items-center rounded-full pl-16 pr-6 font-poppins'
                                >
                                    <span className="flex justify-center items-center">
                                        <IoChevronForwardOutline className="h-[22px] w-[25px] ioArrow" />
                                        <BsArrowRightShort className="h-[30px] w-[30px] tailArrow" />
                                    </span>
                                    Brochure
                                </button>
                            </a>
                        </div>                        
                    </div>
                </div>
                <div className="flex justify-center items-center relative min-h-[300px] sm:min-h-[400px] md:min-h-[550px] lg:min-h-[650px] xxl:min-h-[800px] px-4">
                    {/* Gradient Overlay */}
                    <div className="absolute inset-y-0 right-0 w-24 sm:w-32 md:w-56 lg:w-80 bg-gradient pointer-events-none"></div>

                    {/* Image Container */}
                    <div className="relative z-10 w-full max-w-[90vw] md:max-w-[85vw] lg:max-w-[80vw] xl:max-w-[75vw] 2xl:max-w-[1200px] bg-grey rounded-3xl overflow-hidden px-4 py-4 xLg:mr-[205px]">
                        <img
                            loading="lazy"
                            src={VeryconVariants2Left}
                            alt="Verycon 2.0"
                            className="w-full h-auto max-h-[90vh] object-contain"
                        />
                    </div>
                </div>

            </div>
            {isModalOpen && <FormModal isModalOpen={isModalOpen} productTitle={productTitle} setIsModalOpen={setIsModalOpen} />}
        </section>
    );
};

export default Verycon2;
